<style lang="scss" scoped>
.half_item {
  width: 50%;
  float: left;
  box-sizing: border-box;
  padding-right: 20px;

  &:nth-child(2n) {
    padding-right: 0;
    padding-left: 20px;
  }
}

.btn_panel {
  text-align: center;
  padding-top: 20px;
}

.required-icon {
  color: red;
  position: absolute;
  left: -86px;
  top: 2px;
  z-index: 2;
}

.type-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-top: 20px;
  margin-bottom: 8px;
}

.money-sum {
  overflow: hidden;

  .empty {
    text-align: center;
    background-color: $bg-color-sidebar;
    padding: 10px;
    border-radius: 4px;
  }

  .sum-item {
    float: left;
    margin-right: 20px;
    background-color: $bg-color-sidebar;
    padding: 10px;
    border-radius: 4px;

    .kind {
      color: $text-primary;
    }

    .moneoy {
      color: $color-danger;
      font-size: 18px;
      display: inline-block;
    }
  }
}
</style>
<template>
  <div v-loading="isPageLoading">
    <el-form ref="formDataRef" :model="formData" label-width="80px"
      label-position="left"
      class="clearfix"
      size="medium">
      <el-form-item prop="basic_type" class="half_item" label="审批类型">
        <s class="required-icon">*</s>
        <el-select v-model="formData.basic_type" placeholder="请选择审批类型"
          :collapse-tags="false"
          multiple
          style="width: 100%;">
          <el-option
            v-for="item in approvalInstanceType"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="status" class="half_item" label="审批状态" v-if="false">
        <s class="required-icon">*</s>
        <el-select v-model="formData.status" placeholder="请选择审批记录的状态"
          clearable
          style="width: 100%;">
          <el-option
            v-for="item in statusList"
            :key="item.status"
            :label="item.name"
            :value="item.status">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="keyword	" class="half_item" label="关键字">
        <el-input v-model="formData.keyword" placeholder="请输入关键字：发起人、标题等"></el-input>
      </el-form-item>
      <el-form-item prop="create_time" class="half_item" label="发起时间">
        <s class="required-icon">*</s>
        <el-date-picker
          style="width: 100%;"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="formData.create_time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="complete_time	" class="half_item" label="完成时间">
        <el-date-picker
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="formData.complete_time"
          style="width: 100%;"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="owner_company_id	" class="half_item" label="出款方主体">
        <el-select v-model="formData.owner_company_id" placeholder="请选择出款方主体"
          filterable style="width: 100%;" clearable>
          <el-option-group v-for="group in ownerCompanys"
            :key="group.label"
            :label="group.label">
            <el-option
              v-for="item in group.option"
              :label="item.name"
              :key="item.id"
              :value="item.id">
              {{item.name}}
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item prop="other_company_id" class="half_item" label="收款方主体">
        <el-select v-model="formData.other_company_id" placeholder="请选择收款方主体"
          filterable style="width: 100%;" clearable>
          <el-option-group v-for="group in otherCompanys"
            :key="group.label"
            :label="group.label">
            <el-option
              v-for="item in group.option"
              :label="item.name"
              :key="item.id"
              :value="item.id">
              {{item.name}}
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>


      <el-form-item v-if="showProjectList" prop="company_project_id" class="half_item"
        label="关联项目">
        <el-select v-model="formData.company_project_id" filterable placeholder="请选择关联项目"
          style="width: 100%;" clearable>
          <el-option
            v-for="item in projects"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="btn_panel">
      <el-button type="primary" @click="confirmBtnHandler">统计查询</el-button>
    </div>
    <div class="type-title">统计汇总：</div>
    <div class="money-sum" v-if="sumMoneys && sumMoneys.length > 0">
      <div class="sum-item" v-for="(moneyItem) in sumMoneys" :key="moneyItem.coin_type">
        <em class="kind">{{moneyItem.coin_type}}：</em><span
          class="moneoy">{{moneyItem.sum_money}}</span>
      </div>
    </div>
    <div class="money-sum" v-else>
      <div class="empty">暂无数据</div>
    </div>
    <div class="type-title">明细列表：</div>
    <div class="table-list">
      <el-table
        :data="detailItems"
        size="small"
        style="width: 100%;">
        <el-table-column
          prop="name"
          label="类型">
          <template slot-scope="scope">
            <span>{{scope.row.basic_info?scope.row.basic_info.name :   '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="标题">
          <template slot-scope="scope">
            <!-- <span>{{scope.row.basic_info?scope.row.basic_info.name :   '--'}}</span> -->
            <span>{{scope.row.title}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="serial_number"
          label="编号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="promoter"
          label="发起人">
        </el-table-column>
        <el-table-column
          prop="coin_type"
          label="币种">
        </el-table-column>
        <el-table-column
          prop="money"
          label="实际金额">
        </el-table-column>
        <el-table-column
          prop="start_time"
          width="150"
          label="发起时间">
        </el-table-column>
        <el-table-column
          prop="end_time"
          width="150"
          label="完成时间">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
          <template slot-scope="scope">
            <el-tag :type="approvalInstanceStatus.constMap.idMap[scope.row.status].class"
              size="mini">{{approvalInstanceStatus.constMap.idMap[scope.row.status].name}}
            </el-tag>
          </template>

        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { approvalInstanceType, statusList, approvalInstanceStatus } from '@/const'
import { getCompanyList } from '@/api/company'
import { getProjects } from '@/api/project'
import { getApprovalInstanceCountList } from '@/api/approval'
import dayjs from 'dayjs'

export default {
  name: 'approval-review',
  data() {
    return {
      statusList,
      approvalInstanceType,
      approvalInstanceStatus,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = dayjs();
            const start = end.subtract(6, 'days');
            picker.$emit('pick', [start.toDate(), end.toDate()]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = dayjs();
            const start = end.subtract(1, 'months');
            picker.$emit('pick', [start.toDate(), end.toDate()]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = dayjs();
            const start = end.subtract(3, 'months');
            picker.$emit('pick', [start.toDate(), end.toDate()]);
          }
        }]
      },
      otherCompanys: [],
      ownerCompanys: [],
      projects: [],
      isPageLoading: false,
      isTableLoading: false,
      formData: {
        basic_type: [],
        per_page: 20000,
        status: '',
        keyword: '',
        create_time: [],
        complete_time: [],
        create_time_start: '',
        create_time_end: '',
        complete_time_start: '',
        complete_time_end: '',
        owner_company_id: '',
        other_company_id: '',
        company_project_id: ''
      },
      tableData: [],
      detailItems: [],
      sumMoneys: []
    }
  },
  methods: {
    async initPage() {
      this.isPageLoading = false
      try {
        const companysRes = await getCompanyList({ page: 1, per_page: 10000 })
        let companys = []
        if (companysRes && companysRes.code === 0 && companysRes.data) {
          companys = companysRes.data.items || []
          this.initSelectOption(companys)
        }
        this.isPageLoading = false
      } catch (err) {/* */ }
      this.isPageLoading = false
      const projectsRes = await getProjects({ page: 1, per_page: 20000 })
      if (projectsRes && projectsRes.code === 0 && projectsRes.data) {
        this.projects = projectsRes.data.items || []
      }
    },
    initSelectOption(companys) {
      const ownerCompanys = []
      const supplierCompanys = []
      const clientCompanys = []
      companys.forEach(item => {
        if (item.type == 1) ownerCompanys.push(item)
        if (item.type == 2) supplierCompanys.push(item)
        if (item.type == 3) clientCompanys.push(item)
      })

      this.ownerCompanys = [
        {
          label: '我方公司',
          option: ownerCompanys
        }
      ]
      this.otherCompanys = [
        {
          label: '供应商',
          option: supplierCompanys
        },
        {
          label: '客户',
          option: clientCompanys
        }
      ]
    },
    confirmBtnHandler() {
      const formData = JSON.parse(JSON.stringify(this.formData))

      if (!Array.isArray(formData.basic_type) || formData.basic_type.length <= 0) {
        return this.$message.error('审批类型不能为空')
      }

      if (!Array.isArray(formData.create_time) || !formData.create_time[0] || !formData.create_time[1]) {
        return this.$message.error('发起时间不能为空')
      }

      const query = this.formData
      query.__ = new Date().getTime()
      this.$router.replace({
        path: '/approval/instance/review',
        query
      })
    },


    renderPage(formData) {
      formData = JSON.parse(JSON.stringify(formData))
      formData.create_time_start = formData.create_time[0]
      formData.create_time_end = formData.create_time[1]
      formData.complete_time_start = formData.complete_time[0] || ''
      formData.complete_time_end = formData.complete_time[1] || ''
      delete formData.create_time
      delete formData.complete_time

      const diffCreateTime = dayjs(formData.create_time_start).diff(dayjs(formData.create_time_end), 'days')
      const diffCompleteTime = dayjs(formData.complete_time_start).diff(dayjs(formData.complete_time_end), 'days')

      if (!!diffCreateTime && Math.abs(diffCreateTime) > 100) {
        return this.$message.error('发起时间最大间隔不能超过100天，请重新选择')
      }
      if (!!diffCompleteTime && Math.abs(diffCompleteTime) > 100) {
        return this.$message.error('完成时间最大间隔不能超过100天，请重新选择')
      }

      this.isPageLoading = true
      this.sumMoneys = []
      this.detailItems = []
      getApprovalInstanceCountList(formData).then(res => {
        if (res.code != 0 || !res.data) throw new Error(res.message)
        const sumMoneys = res.data.sum_money || []
        const items = res.data.items || []
        this.sumMoneys = sumMoneys
        this.detailItems = items
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.isPageLoading = false
      })
    },
    initParams(query = {}) {
      console.log('query', query)
      this.formData = {
        basic_type: query.basic_type ? (Array.isArray(query.basic_type) ? query.basic_type : [query.basic_type]) : [],
        per_page: 20000,
        keyword: query.keyword || '',
        status: +query.status || '',
        create_time: query.create_time || [],
        complete_time: query.complete_time || [],
        owner_company_id: +query.owner_company_id || '',
        other_company_id: +query.other_company_id || '',
        company_project_id: +query.company_project_id || '',
        create_time_start: '',
        create_time_end: '',
        complete_time_start: '',
        complete_time_end: ''
      }
    }
  },
  computed: {
    showProjectList() {
      const idMap = approvalInstanceType.constMap.idMap || {}
      let hasBaoXiao = false
      this.formData.basic_type.forEach(id => {
        const basicItem = idMap[id]
        if (basicItem.enName === 'applayReimbursement') {
          hasBaoXiao = true
        }
      })
      return hasBaoXiao
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.initParams(to.query)
    this.renderPage(this.formData)
    next();
  },

  created() {
    this.initParams(this.$route.query)
    this.initPage()
    console.log('this.formData.create_time', this.formData.create_time)
    console.log('this.formData.create_time', this.formData.create_time)
    if (this.formData.basic_type.length > 0 && this.formData.create_time[0] && this.formData.create_time[1]) {
      this.renderPage(this.formData)
    }
  }

}
</script>
